import { Input } from "../../../../base/components/native/input"
import { simpleInputStyle } from "./simple-input.style"

export const simpleInput = (placeholder?: string) => {
    // set input placeholder to right

    const base = Input(placeholder, 'text')
    base.el.dir = 'rtl'
    base.on('input', () => {
        base.el.dir = base.el.value.length > 0 ? 'auto' : 'rtl'
    })
    base.cssClass(simpleInputStyle)

    return base

}